import styled from 'styled-components'

export const StopIndex = styled.div<{ color?: string; bgColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 21px;
  height: 21px;
  border-radius: 50%;
  background-color: ${({ bgColor }): string => bgColor || '#e3e3e3'};
  color: ${({ color }): string => color || '#717171'};
  font-size: 12px;
  font-weight: 500;
`
